import {createInteractionId, applyInteractionId} from '@servicenow/ui-metrics';
import {normalizeActionMeta} from './normalizeActionMeta';

function applyMetricsToDispatch(dispatch) {
	return (type, payload, meta = {}, error) => {
		// eslint-disable-next-line no-param-reassign
		meta = normalizeActionMeta(meta, {});
		applyInteractionId(meta);
		return dispatch(type, payload, meta, error);
	};
}

export default function applyMetrics(helpers, interactionId = createInteractionId()) {
	const withMetrics = typeof helpers === 'function' ? applyMetricsToDispatch(helpers) : {};

	if (helpers.updateState)
		withMetrics.updateState = (...args) => helpers.updateState(...args, interactionId);

	if (helpers.updateContext)
		withMetrics.updateContext = (...args) => helpers.updateContext(...args, interactionId);

	if (helpers.updateProperties)
		withMetrics.updateProperties = (...args) => helpers.updateProperties(...args, interactionId);

	if (helpers.dispatch) withMetrics.dispatch = applyMetricsToDispatch(helpers.dispatch);

	return withMetrics;
}
